var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultSortConfigs, } from '../models/b2b/add-manage-users';
export var generateSortByOptions = function (sortByLabel, options) {
    return __assign(__assign({}, defaultSortConfigs[sortByLabel]), (options || {}));
};
